/**
 * @fileoverview Modal host for the custom export builder (MOR-1048).
 *
 * Wraps `CustomExportBuilder` in a wide dialog so any export surface can
 * open the tool from its export menu. Surfaces either hand over ready-made
 * datasets or the `ExportContent` they already build for Excel (via
 * `datasetsFromContent`).
 *
 * Render the dialog as a sibling of the dropdown/popover that triggers it —
 * Radix unmounts menu content on close, which would take the dialog with it.
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/ui/composed/overlays/dialog";
import { CustomExportBuilder } from "./CustomExportBuilder";
import type { CustomExportDataset } from "./engine";

export function CustomExportDialog({
  open,
  onOpenChange,
  datasets,
  title,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  datasets: CustomExportDataset[];
  /** Title seed for the export filename, e.g. the surface's page title. */
  title?: string;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[92vh] w-[min(72rem,95vw)] max-w-none flex-col overflow-hidden">
        <DialogHeader>
          <DialogTitle>Custom export</DialogTitle>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-y-auto pr-1">
          {datasets.length === 0 ? (
            <p className="py-6 text-sm text-muted-foreground">
              Nothing to export yet — this view has no tabular data.
            </p>
          ) : (
            <CustomExportBuilder datasets={datasets} defaultTitle={title} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
